import UAParser from 'ua-parser-js';

// List of supported browsers and versions by operating system for launchpad.
const supportedBrowserVersions = {
  mobile: {
    Chrome: 83,
    'Chrome WebView': 1,
    Firefox: 69,
    'Mobile Safari': 11,
    WebKit: 1,
    Safari: 11
  },
  desktop: {
    Chrome: 83,
    Firefox: 77,
    Edge: 83,
    Safari: 12,
    WebKit: 1
  }
};

const isSupported = (browser, deviceType) => {
  if (browser.name === 'IE' && browser.version < 11) {
    window.location.assign('/unsupported.html');
  }

  let browserVersion = supportedBrowserVersions.desktop[browser.name];
  if (deviceType === 'mobile' || deviceType === 'tablet') {
    browserVersion = supportedBrowserVersions.mobile[browser.name];
  }

  if (browserVersion) {
    return parseInt(browser.version, 10) + 3 >= browserVersion;
  }

  return false;
};

/**
 * Send unsupported browser/os combinations to our "Sorry!" page
 */
export const validateBrowserSupport = () => {
  // Parse the UA string.
  const parser = new UAParser();
  let browser = parser.getBrowser();
  const device = parser.getDevice();

  if (isSupported(browser, device.type)) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/modules/app/services/browser-checker.js